<template>
    <div class="theme-book">
        <!-- 精选推荐 -->
        <div class="recommended-section" v-if="selectlist.length > 0">
            <div class="section-header">
                <h3>精选推荐</h3>
                <button class="more-btn">换一批</button>
            </div>
            <div class="recommended-cards">
                <div class="card card-1" v-for="(item, index) in selectlist" :key="index" @click="goBooklistDetails(item)">
                    <div class="card-image">
                        <img :src="item.imgUrl" alt="book cover" @error="handleError" class="image-placeholder">

                    </div>
                </div>
                
            </div>
        </div>

        <!-- 所有书单 -->
        <div class="all-books-section" v-if="booklist.list.length > 0">
            <div class="section-header">
                <h3>所有书单</h3>
            </div>
            <div class="books-grid">
                <div class="book-item" v-for="(item, index) in booklist.list" :key="index" @click="goBooklistDetails(item)">
                    <div class="book-image">
                        <img :src="item.imgUrl" alt="book cover" @error="handleError" class="image-placeholder">
                    </div>
                    <div class="book-title" :title="item.groupName">{{ item.groupName }}</div>

                    <div class="book-icons">
                        <div class="icon-item" v-if="item.relaCount.bookCount">
                            <img src="../../assets/readimg/books.svg" alt="" class="icon-placeholder">
                            <span>{{ item.relaCount.bookCount }}本</span>
                        </div>
                        <div class="icon-item" v-if="item.relaCount.audioCount">
                            <img src="../../assets/readimg/ear.svg" alt="" class="icon-placeholder">
                            <span>{{ item.relaCount.audioCount }}本</span>
                        </div>
                        <div class="icon-item" v-if="item.relaCount.videoCount">
                            <img src="../../assets/readimg/list.svg" alt="" class="icon-placeholder">
                            <span>{{ item.relaCount.videoCount }}门</span>
                        </div>
                    </div>
                </div>
            </div>

            <pagination
                :total="booklist.total"
                :page-size="booklist.pageSize"
                :current-page.sync="booklist.pageIndex"
                @change="handlePageChange"
            />

        </div>
    </div>
</template>

<script>
import api from '@/api/index.js';
import defaultImg1 from '@/assets/readimg/defaultImg1.png';
import defaultImg2 from '@/assets/readimg/defaultImg2.png';
import pagination from './components/pagination.vue';
export default {
  name: 'themeBook',
  components: {
    pagination
  },
  data() {
    return {
      selectlist: [],
      booklist: {
        pageIndex: 1,
        pageSize: 9,
        list: [],
        total: 0
      },
      

    }
  },
  props: {
        parentScrollRef: {  // 父组件传递的滚动容器ref名称
            type: String,
            default: 'main'
        }
    },
  mounted() {
    this.getSelectlist();
    this.getBooklist();
    this.scrollParentToTop()
  },
  methods: {
    scrollParentToTop() {
        // 1. 获取父组件的滚动容器DOM
        const parentScrollContainer = this.$parent.$refs[this.parentScrollRef];
        if (!parentScrollContainer) {
            console.error('未找到父组件滚动容器，请检查ref是否正确');
            return;
        }
        parentScrollContainer.scrollTop = 0;
    },
    getSelectlist() {
        try{
            api.themeRecommend({
                pageNum: 0,
                pageSize: 3,
            }).then((res) => {
                if(res.data.status == 1){
                    this.selectlist = res.data.data;
                }
            })
        }catch(error){
            this.$message.error(error.message);
        }
    },
    getBooklist() {
        try{
            api.themeList({
                pageIndex: this.booklist.pageIndex - 1,
                pageSize: this.booklist.pageSize,
            }).then((res) => {
                if(res.data.status == 1){
                    this.booklist.list = res.data.data;
                    this.booklist.total = res.data.total;
                }
            })
        }catch(error){
            this.$message.error(error.message);
        }
    },
    handlePageChange(page,size) {
        this.booklist.pageIndex = page;
        this.booklist.pageSize = size;
        this.getBooklist();
    },

    goBooklistDetails(item) {
      this.$router.push({
        path: '/read/booklistDetails',
        query: {
          id: item.ID,
          bookListID: item.groupID,

        }
      })
    },
    handleError(event){
        event.target.src = defaultImg1;
    },
  }
}
</script>

<style lang="scss" scoped>
.theme-book {
    padding: 0;
    background: #f7f7f7;
    margin-top: 30px;
}

// 精选推荐
.recommended-section {
    max-width: 1200px;
    margin: 0 auto 40px;
    padding: 0 20px;
    
    .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        
        h3 {
            font-size: 24px;
            margin: 0;
            color: #333;
        }
        
        .more-btn {
            background: white;
            border: 1px solid #ddd;
            padding: 8px 30px;
            border-radius: 22px;
            cursor: pointer;
            font-size: 14px;

            &:hover{
                border: 1px solid #e6564e;
                color: #e6564e;
            }
        }
    }
    
    .recommended-cards {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 25px;
        
        .card {
            position: relative;
            border-radius: 8px;
            overflow: hidden;
            height: 200px;
            transition: transform 0.3s ease;
            cursor: pointer;
            
            .card-image {
                width: 100%;
                height: 100%;       
                
                .image-placeholder {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    background: #ddd;
                }
            }
            &:hover{
                transform: scale(1.05);
                transition: transform 0.3s ease;
            }
        }
    }
}

// 所有书单
.all-books-section {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    
    .section-header {
        margin-bottom: 20px;

        h3{
            font-size: 24px;
            margin: 0;
            color: #333;
        }
    }
    
    .books-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 25px;
        
        .book-item {
            background: white;
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
            transition: transform 0.3s ease;
            cursor: pointer;
            
            .book-image {
                width: 100%;
                height: 150px;
                
                .image-placeholder {
                    width: 100%;
                    max-height: 100%;
                    object-fit: cover;
                    background: #ddd;
                }
            }
            
            .book-title {
                padding: 15px 20px 10px;
                font-size: 16px;
                font-weight: 500;
                color: #333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            
            .book-icons {
                display: flex;
                padding: 0 20px 15px;
                gap: 15px;
                
                .icon-item {
                    display: flex;
                    align-items: center;
                    color: #e6564e;
                    background: #ffefef;
                    border-radius: 5px;
                    padding: 8px 14px;
                    gap: 10px;
                    
                    .icon-placeholder {
                        width: 16px;
                        height: 16px;
                    }
                    
                    span {
                        font-size: 12px;
                    }
                }
            }

            &:hover{
                transform: scale(1.05);
                transition: transform 0.3s ease;
            }
        }
    }
}

// 响应式设计
@media (max-width: 768px) {
    .recommended-cards {
        grid-template-columns: 1fr !important;
    }
    
    .books-grid {
        grid-template-columns: repeat(2, 1fr) !important;
    }
    
    .banner-content {
        flex-direction: column;
        text-align: center;
        gap: 20px;
    }
}

@media (max-width: 480px) {
    .books-grid {
        grid-template-columns: 1fr !important;
    }
}
</style>